import '@babel/polyfill';

// import polyfills
import 'intersection-observer';

// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/_fortawesome.js"; import "./autoload/fullpage.responsiveSlides.min.js"

// import external dependencies
import 'jquery';
import 'daterangepicker';
import 'ion-rangeslider';


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singlePost from './routes/singlePost';
import meetTheBoard from './routes/meetTheBoard';
import airlinePartners from './routes/airlinePartners';
import latest from './routes/latestPosts';
import inOurDna from './routes/inOurDna';
import careers from './routes/careers';
import resources from './routes/resources';
import ourStory from './routes/ourStory';
import contactUs from './routes/contact';
// // import corporateGovernance from './routes/corporateGovernance';
import citizenship from './routes/citizenship';
import aircraftPortfolio from './routes/aircraftPortfolio';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // // All pages
    common,
    // // Home page
    home,
    // // single post
    singlePost,
    // // Meet the board (Team page)
    meetTheBoard,
    // // portfolio -> airline partners
    airlinePartners,
    // // archive page for posts
    latest,
    inOurDna,
    careers,
    resources,
    ourStory,
    contactUs,
    // // corporateGovernance,
    citizenship,
    aircraftPortfolio,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js